export const apiUrls = {
    REGISTER:"/v3/auth/register",
    LOGIN:"/v3/auth/login",
    TABLE_DATA:"/v3/configs/lists",
    REFRESH_TOKEN_URL:'/v3/auth/refresh',
    POS_CUSTOMERS_URL:'/v3/pos-customers',
    POS_CUSTOMER_PROFILE:'/v3/pos-customers/profile', 
    POS_CUSTOMERS_CREATE_URL:'/v3/pos-customers/create',
    ORDER_MAIN_URL:'/v3/orders',
    ORDER_LISTS_URL:'/v3/orders/lists',
    CATEGORY_LISTING:"/v3/category/listing",
    ORDER_DETAILS_URL:'/v3/orders/get-order-by-id',
    ORDER_LOOKUP:'/v3/orders/lookup',
    ORDER_PRINT_URL:'/v3/orders/print',
    MENU_DISHES:'/v3/orders/menu-dishes',
    ADD_TO_CART:'/v3/cart/add-default-dish-to-cart',
    GET_ADDED_TO_CART:'/v3/cart/checkout-cart-details',
    UPDATE_QUANTITY:'/v3/cart/update-quantity',
    REMOVE_CART_ITEM:'/v3/cart/remove-cart-item',
    ADD_TO_CART_DETAIL:'/v3/cart/add-to-cart',
    CART_ITEM_DETAILS:'/v3/cart/cart-item-details',
    UPDATE_CART_DETAIL:'/v3/cart/update-cart',
    GET_OERDER_TYPE:'/v3/cart/get-order-type',
    GET_TIME_SLOTS:'/v3/cart/get-time-slots',
    EXPRESS_CHECKOUT:'/v3/orders/express-checkout',
    ORDER_CREATE:'/v3/orders/order-create',
    CHECKOUT_SUMMARY_DETAILS:'/v3/dish/checkout-summary-details',
    GET_ORDER_TYPE_NUM:'/v3/orders/order-type',
    CONFIGURED_PAYMENT_MODE:'/v3/cart/configured-payment-modes',
    CUSTOMER_AUTOCOMPLETE:'/v3/customer/autocomplete',
    MEMBERSHIP_LOOKUP:'/v3/membership/lookup',
    MEMBERSHIP_READ_CARD:'/v3/membership/read-card',
    UPDATE_ORDER_CUSTOMER:'/v3/orders/update-order-customer',
    GET_ORDER_INFO:'/v3/orders/get-order-info',
    SAVE_CUSTOMER:'/v3/customer/save-customer',
    UPDATE_CUSTOMER:'/v3/customer/update-customer-session-id', //not in use abhi
    CUSTOMER_DETAILS:'/v3/customer/single',
    CUSTOMER_DELIVERY_ADDRESS:'/v3/customer/customer-delivery-address',
    SAVE_DELIVERY_ADDRESS:'/v3/customer/save-delivery-address',
    UBEREATS_EXISTING_LIST_STORES:'/v3/ubereats/existing-list-stores',
    UBEREATS_LISTING:'/v3/ubereats/listing',
    UBEREATS_STORES_LISTING:'/v3/ubereats/stores-listing',
    UBEREATS_AUTHORIZE:'/v3/ubereats/authorize',
    UBEREATS_DISCONNECT:'/v3/ubereats/disconnect-uber-account',
    UBEREATS_ACCEPT:'/v3/ubereats/accept-order',
    UBEREATS_REJECT:'/v3/ubereats/deny-order',
    UBEREATS_CANCEL:'/v3/ubereats/cancel-order',
    UBEREATS_MARK_READY:'/v3/ubereats/mark-order-ready',
    UBEREATS_INTEGRATE_STORE:'/v3/ubereats/integrate-store',
    TABLE_LISTING: '/v3/orders/table-listing',
    UPDATE_TABLE_OCCUPANCY: '/v3/orders/update-table-occupancy',
    ORDER_BY_TABLE_ID: '/v3/orders/get-order-by-table-id',
    UPDATE_TABLE_ORDERS: '/v3/orders/table-orders-update',
    RELEASE_PAGER_OCCUPANCY: '/v3/orders/release-pager-occupancy',
    RECEIPT_SUMMARY: '/v3/orders/receipt-summary',
    RESERVATION_UPDATE_STATUS:'/v3/reservations/update-status',
    RESERVATION_CANCEL:'/v3/reservations/cancel',
    RESERVATION_LISTING:'/v3/reservations/listing',
    RESERVATION_LISTING_CAL:'/v3/reservations/listingcal',
    RESERVATION_RECIPIENTS:'/v3/reservations/recipients',
    RESERVATION_CREATE:'/v3/reservations/creates',
    RESERVATION_LIST:'/v3/reservations/list',
    RESERVATION_TABLE_LIST:'/v3/reservations/table-list',
    RESERVATION_ASSIGN_TABLE:'/v3/reservations/assign-table',
    RESERVATION_DELETE_BOOKING:'/v3/reservations/delete-booking',
    RESERVATION_GET_DETAILS:'/v3/reservations/get-details',
    RESERVATION_UPDATE_BOOKING:'/v3/reservations/update-booking',
    RESERVATION_TIME_SLOTS_AVAILABLE:'/v3/reservations/time-slots-available',
    RESERVATION_CLEAR_NO_SHOWS:'/v3/reservations/clear-no-shows',
    RESERVATION_SEND_REMINDER:'/v3/reservations/send-reminder',
    RESERVATION_BOOKINGS_PRINT:'/v3/reservations/bookings-print',
    RESERVATION_BOOKINGS_PDF:'/v3/reservations/bookings-pdf',
    RESERVATION_BOOKINGS_EMAIL:'/v3/reservations/bookings-email',
    RESERVATION_BOOKINGS_LINK:'/v3/reservations/bookings-link',
    REVENUE_LISTING:'/v3/revenue/listing',
    REVENUE_PDF_DATA_FORMAT:'/v3/revenue/revenue-pdf-format',
    REVENUE_SEND_PDF:'/v3/revenue/send-revenue-pdf',
    REVENUE_UPDATE:'/v3/revenue/updates',
    REVENUE_RESERVATIONS_BREAKDOWN:'/v3/revenue/reservations-breakdown',
    REVENUE_DELETED_ITEMS_REPORT:'/v3/revenue/deleted-items-report',
    REVENUE_DELETED_ITEMS_DETAIL:'/v3/revenue/deleted-items-detail',
    REVENUE_DELETED_ORDERS_DETAIL:'/v3/revenue/deleted-orders-detail',
    REVENUE_SALES_BY_CATEGORY:'/v3/revenue/sales-by-category',
    REVENUE_SALES_BY_SUB_CATEGORY:'/v3/revenue/sales-by-sub-category',
    REVENUE_PRINT:'/v3/revenue/print',
    REVENUE_PDF:'/v3/revenue/pdf',
    REVENUE_EMAIL:'/v3/revenue/email',
    REVENUE_SHARE_LINK:'/v3/revenue/share-link',
    REVENUE_AUTOMATION_SETTINGS:'/v3/revenue/automation-settings',
    REVENUE_UPDATE_AUTOMATION_SETTINGS:'/v3/revenue/update-automation-settings',
    EMPOLYEE_LISTING:'/v3/customer/employee-listing',
    VALIDATE_PIN:'/v3/customer/validatepin',
    TIMESHEET_VALIDATE_PIN:'/v3/timesheet/validate-pin',
    TIMESHEET_CHECKIN:'/v3/timesheet/checkin',
    TIMESHEET_CHECKOUT:'/v3/timesheet/checkout',
    TIMESHEET_HISTORY:'/v3/timesheet/history',
    TIMESHEET_TEAM_STAFF:'/v3/timesheet/team-staff',
    TIMESHEET_TEAM_HISTORY:'/v3/timesheet/team-history',
    CHECK_IN_HISTORY:'/v3/customer/checkinhistory',
    CHECKIN_CHECKOUT:'/v3/customer/checkincheckout',
    OCCUPIED_TABLE_WITH_ORDERS:'/v3/table/occupied',
    GET_CART_ITEMS_BY_TABLE:'/v3/cart/get-cart-items-by-table-id',
    REPEAT_ITEMS:'/v3/cart/repeat-cart-items',
    CHECKOUT_DISH_DETAILS:'/v3/dish/checkout-dish-details',
    OFFERS_LOYALTY_POINTS:'/v3/dish/get-offers-loyalty-points',
    GET_EXISTING_ORDER_TABLE:'/v3/orders/get-existing-order-table',
    CART_ORDER_PAYMENT:'/v3/orders/order-payment',
    ORDER_PAYMENT:'/v3/cart/payment',
    PRINT_BILL:'/v3/cart/printdocket',
    VOUCHER_VALIDITY: '/v3/promotion/checkout-voucher-validity',    
    CHECK_LAST_LINKLY_PAYMENT: '/v3/linkly-payment/checklastlinklypayment',
    LINKLY_REFUND: '/v3/linkly-payment/refund',
    //LINKLY_STATUS: '/v3/linkly-payment/index',
    LINKLY_STATUS: '/v3/linkly-payment/check-status',
    LINKLY_CHECK_RETRY: '/v3/linkly-payment/checkstatusandretry',
    LINKLY_STATUS_MANUAL: '/v3/linkly-payment/status-manually',
    LINKLY_SEND_KEY: '/v3/linkly-payment/send-key',
    LINKLY_RETRY: '/v3/linkly-payment/retry',
    PENDING_ORDERS_LISTING: '/v3/orders/pending-orders-listing',
    REMOVE_PENDING_ORDER: '/v3/orders/remove-pending-order',
    RESUME_PENDING_ORDER: '/v3/orders/resume-pending-order',
    RESUME_PHONE_ORDER: '/v3/orders/resume-phone-order',
    GET_CART_BY_ID:'/v3/cart/get-cart-by-id',
    CART_ADD_COMMENT: '/v3/cart/add-comment',
    CART_COMMENT_OPTIONS: '/v3/cart/comment-options',
    PRINT_KITCHEN_DOCKET:'/v3/orders/table-kitchen-print',
    GET_ORDER_CUSTOMER_DETAILS: '/v3/orders/get-order-customer-details',
    DELETE_ORDERS: '/v3/orders/delete-orders',
    VOID_ORDER: '/v3/orders/void-order',
    UPDATE_ORDER_STATUS: '/v3/orders/update-orders-status',
    EDIT_ORDER_DRIVER:'/v3/orders/edit-order-driver-details',
    UPDATE_ORDER_DRIVER:'/v3/orders/update-order-driver-details',
    SET_TABLE_PEOPLE:'/v3/configs/set-table-people',
    RESERVATION_CHECKIN_OPTIONS:'/v3/reservations/checkin-options',
    POS_CUSTOMERS_UPDATE_SUBSCRIBE:'/v3/customer/update-subscribed-status',
    SET_ORDER_ADDRESS:'/v3/orders/set-order-address',
    PROMO_LISTING:'/v3/promotion/listing',
    PROMO_RESTAURANT_BACKEND:'/v3/promotion/restaurant-domain',
    PROMO_CREATE:'/v3/promotion/create-offer',
    PROMO_UPDATE:'/v3/promotion/update-offer',
    PROMO_DISH_OPTIONS:'/v3/promotion/dish-options',
    PROMO_TARGET_OPTIONS:'/v3/promotion/target-options',
    SAVE_CUSTOMER_NAME:'/v3/customer/save-customer-name',
    CALL_FETCH: '/v3/call-notification/fetch-call',
    CALL_MARK_SENT: '/v3/call-notification/mark-sent',
    CALL_MARK_COMPLETED: '/v3/call-notification/mark-completed',
    CALL_MARK_DISMISSED: '/v3/call-notification/mark-dismissed',
    TOM_INITIATE:'/v3/cart/initiate',
    OPEN_DRAWER:'/v3/cart/open-drawer',
    DEAL_DATA: '/v3/deals/deal-data',
    PRODUCT_RECIPE: '/v3/deals/product-recipe',
    HALF_AND_HALF_CONFIG: '/v3/half-and-half/config',
    HALF_AND_HALF_PORTION_PRODUCTS: '/v3/half-and-half/portion-products',
    HALF_AND_HALF_ADD_TO_CART: '/v3/half-and-half/add-to-cart',
    EMPTY_OCCUPANCY:'/v3/orders/empty-occupancy',
    CREATE_STRIPE_PAYMENT_LINK: '/v3/payment-link/create-stripe-payment-link',
    SEND_STRIPE_PAYMENT_LINK: '/v3/payment-link/send-stripe-payment-link',
    PAYMENT_LINK_STATUS: '/v3/payment-link/payment-link-status',
    PAYMENT_LINK_COUNTS: '/v3/payment-link/payment-link-counts',
    PAYMENT_LINK_LIST: '/v3/payment-link/payment-link-list',
    ACKNOWLEDGE_PAYMENT_LINK: '/v3/payment-link/acknowledge-payment-link',
    GET_CUSTOM_ITEM_PRODUCT:'/v3/cart/get-custom-product',
    REVENUE_VALIDATE_PIN:'/v3/revenue/validate-pin',

    // Product management
    PRODUCT_MANAGEMENT_PRODUCTS: '/v3/product-management/products',
    PRODUCT_MANAGEMENT_CREATE_PRODUCT: '/v3/product-management/create-product',
    PRODUCT_MANAGEMENT_UPDATE_PRODUCT: '/v3/product-management/update-product',
    PRODUCT_MANAGEMENT_CATEGORIES: '/v3/product-management/categories',
    PRODUCT_MANAGEMENT_UPDATE_CATEGORY: '/v3/product-management/update-category',
    PRODUCT_MANAGEMENT_SUBCATEGORIES: '/v3/product-management/subcategories',
    PRODUCT_MANAGEMENT_UPDATE_SUBCATEGORY: '/v3/product-management/update-subcategory',
    PRODUCT_MANAGEMENT_SIZES: '/v3/product-management/sizes',
    PRODUCT_MANAGEMENT_SET_AVAILABILITY: '/v3/product-management/set-availability',
    PRODUCT_MANAGEMENT_SOLD_OUT: '/v3/product-management/sold-out',
    PRODUCT_MANAGEMENT_STOCK: '/v3/product-management/stock',
    PRODUCT_MANAGEMENT_UPDATE_STOCK: '/v3/product-management/update-stock',
    PRODUCT_MANAGEMENT_SET_STOCK_ENABLED: '/v3/product-management/set-stock-enabled',
    PRODUCT_AI_CHAT: '/v3/product-ai-agent/chat',
    PRODUCT_AI_CONFIRM: '/v3/product-ai-agent/confirm',
    PRODUCT_AI_REJECT: '/v3/product-ai-agent/reject',
    PRODUCT_AI_LOG: '/v3/product-ai-agent/log',
    WEIGHTED_PRODUCTS: '/v3/weighted-products/products',
    WEIGHTED_PRODUCTS_CREATE: '/v3/weighted-products/create-product',
    WEIGHTED_PRODUCTS_UPDATE: '/v3/weighted-products/update-product',
    WEIGHTED_PRODUCTS_DELETE: '/v3/weighted-products/delete-product',

    // Staff identity / roles / permissions
    STAFF_LOGIN_ENABLED: '/v3/configs/get-staff-login-enabled',
    STAFF_AUTH_VALIDATE_PIN: '/v3/staff-auth/validate-pin',

    // Per-location POS settings
    POS_SETTINGS_GET: '/v3/configs/get-pos-settings',
    POS_SETTINGS_UPDATE: '/v3/configs/update-pos-settings',

    // Operating Hours (Delivery/Takeaway/Reservation time slots) - same underlying data as
    // restroadmin's Manage Time Slots page
    TIME_SLOTS_GET_ALL: '/v3/time-slots/get-all',
    TIME_SLOTS_SAVE: '/v3/time-slots/save-slots',
    TIME_SLOTS_REMOVE_SLOT: '/v3/time-slots/remove-slot',
    TIME_SLOTS_REMOVE_RANGE: '/v3/time-slots/remove-range',
    TIME_SLOTS_UPDATE_RESERVATION_LIMIT_TYPE: '/v3/time-slots/update-reservation-limit-type',

    // Floor plan editor / zones
    FLOOR_PLAN_BOOTSTRAP: '/v3/floor-plan',
    FLOOR_PLAN_CREATE_TABLE: '/v3/floor-plan/create-table',
    FLOOR_PLAN_UPDATE_TABLE: '/v3/floor-plan/update-table',
    FLOOR_PLAN_DELETE_TABLE: '/v3/floor-plan/delete-table',
    FLOOR_PLAN_SAVE_LAYOUT: '/v3/floor-plan/save-layout',
    FLOOR_PLAN_CREATE_ELEMENT: '/v3/floor-plan/create-element',
    FLOOR_PLAN_UPDATE_ELEMENT: '/v3/floor-plan/update-element',
    FLOOR_PLAN_DELETE_ELEMENT: '/v3/floor-plan/delete-element',
    FLOOR_PLAN_SAVE_ELEMENTS_LAYOUT: '/v3/floor-plan/save-elements-layout',
    FLOOR_PLAN_IMPORT_ANALYZE: '/v3/floor-plan-import/analyze',
    UPDATE_LAYOUT_MODE: '/v3/configs/update-layout-mode',
    // Customer (second) screen idle logo - per restaurant, stored on the server
    GET_CUSTOMER_SCREEN: '/v3/configs/get-customer-screen',
    UPLOAD_CUSTOMER_SCREEN_LOGO: '/v3/configs/upload-customer-screen-logo',
    REMOVE_CUSTOMER_SCREEN_LOGO: '/v3/configs/remove-customer-screen-logo',
    ZONES_CREATE: '/v3/zones/create',
    ZONES_UPDATE: '/v3/zones/update-zone',
    ZONES_DELETE: '/v3/zones/delete-zone',
    ZONES_REORDER: '/v3/zones/reorder',

    // Hardware / MQTT printer management
    PRINT_FAILURES: '/v3/print-failures/list',
    MQTT_PRINTERS_LIST: '/v3/mqtt-printers/list',
    MQTT_PRINTER_DETAILS: '/v3/mqtt-printers/printer-details',
    MQTT_PRINTER_MASTER_DOCKET_VERSIONS: '/v3/mqtt-printers/master-docket-versions',
    MQTT_PRINTER_CATEGORIES: '/v3/mqtt-printers/categories',
    MQTT_PRINTER_UPDATE_STATUS: '/v3/mqtt-printers/update-status',
    MQTT_PRINTER_UPDATE_PRIMARY: '/v3/mqtt-printers/update-primary',
    MQTT_PRINTER_UPDATE_DOCKET_VERSION: '/v3/mqtt-printers/update-docket-version',
    MQTT_PRINTER_UPDATE_LOCAL_IP: '/v3/mqtt-printers/update-local-ip',
    MQTT_PRINTER_UPDATE_ROLES: '/v3/mqtt-printers/update-roles-status-or-count',
    MQTT_PRINTER_LINK_UNLINK_CATEGORIES: '/v3/mqtt-printers/link-unlink-categories',
    MQTT_PRINTER_SEARCH_ADHOC_ITEMS: '/v3/mqtt-printers/search-adhoc-items',
    MQTT_PRINTER_UPDATE_ITEM_ASSIGNMENT: '/v3/mqtt-printers/update-item-assignment',
};